import { useState, useEffect } from 'react';
import { getResources } from '../../services/dashboard.service';
import { getFileExtentionFromLink } from '../../utils/global';
import Ftux from '../../components/common/Ftux/Ftux';
import DashboardWrapper from '../../components/dashboard/dashboardWrapper/DashboardWrapper';
import ResourceCard from '../../components/dashboard/resourceCard/ResourceCard';
import { Heading } from '../../components/styledComponents';
import styles from '../../styles/dashboard.module.css';

type ResourcesType = {
  _id: string;
  name: string;
  resource: string;
  resourceType: 'media' | 'link';
  userId: string;
  description?: string | undefined;
};

export default function Resources() {
  const [resources, setResources] = useState<undefined | ResourcesType[]>(undefined);

  const fetchResources = async () => {
    const response = await getResources();
    if (response.status) {
      setResources(response.data);
    }
  };

  useEffect(() => {
    fetchResources();
  }, []);

  return (
    <DashboardWrapper heading="Resources">
      <div className="top-bar">
        <Heading as="h3" fontSize="14px" fontWeight="500">
          {resources && resources?.length} Resources Available
        </Heading>
      </div>
      {resources && resources?.length === 0 ? (
        <div className={styles.ftuxContainer}>
          <Ftux
            emoji="📂"
            title="No Resources Added Yet"
            text="List of resources will appear here uploaded by the brand. Please ask them to upload it via SARAL if you need something here!"
          />
        </div>
      ) : (
        <div className={styles.resourcesContainer}>
          {resources &&
            resources.map((data) => (
              <ResourceCard
                key={data._id}
                title={data.name}
                subText={
                  data.resourceType === 'link'
                    ? data?.description
                    : getFileExtentionFromLink(data.resource).toUpperCase()
                }
                type={data.resourceType}
                link={data.resource}
              />
            ))}
        </div>
      )}
    </DashboardWrapper>
  );
}
